import api from "@/api/axios.js";

export async function fetchSettings()
{
	const {data} = await api.get("/api/settings");
	return data?.settings || null;
}

export async function saveSettings(payload)
{
	const {data} = await api.put("/api/settings", payload);
	return data?.settings || null;
}

export async function fetchAvailableAiModels()
{
	const {data} = await api.get("/api/settings/ai/models");
	return data?.models || [];
}

// Campi delle gabbie banner (uguali per tutti i clienti) con l'indicazione `contextMenu`:
// true se compaiono al tasto destro in pre-elaborazione.
export async function fetchBannerFields()
{
	const {data} = await api.get("/api/settings/banner-fields");
	return Array.isArray(data?.fields) ? data.fields : [];
}

export async function saveBannerContextMenuFields(contextMenuKeys)
{
	const {data} = await api.put("/api/settings/banner-fields", {contextMenuKeys});
	return Array.isArray(data?.fields) ? data.fields : [];
}
